import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2467cc8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "horizontal" }
const _hoisted_2 = { class: "horizontal_tab" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "horizontal_tab_line" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "horizontal_list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_tips" }, "标题设置：最多限制为4个字，超出后隐藏", -1))
const _hoisted_8 = { class: "horizontal_list_title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_title" }, "标签列表", -1))
const _hoisted_10 = { class: "list_table" }
const _hoisted_11 = { class: "list_table_title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "标签名称", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "最少保留两个标签，最多八个标签", -1))
const _hoisted_14 = { class: "list_table_content" }
const _hoisted_15 = { class: "content_checkbox" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "horizontal_module" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module_title" }, "模块样式", -1))
const _hoisted_19 = { class: "module_list" }
const _hoisted_20 = ["onClick"]

import emitter from '@/utils/mitt';
import { ref } from 'vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import { Tooltip, Checkbox, message } from 'ant-design-vue';
import Lable from '../subassembly/lable.vue';
import CDelModal from '@/components/CDelModal.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Fold_setup',
  props: {
  custom: {},
},
  setup(__props) {

const props: any = __props;

const aTooltip = Tooltip;
const aCheckbox = Checkbox;



const custom = ref({ ...props.custom });
const title = ref(custom.value.title);
const showTitle = ref(custom.value.showTitle);
// tab切换
const setUp = ref(0);
const getSetUp = (id: number) => {
  setUp.value = id;
};

const toVisualization = () => {
  emitter.emit('visualization', custom.value);
};

// 添加标签
const addTab = () => {
  if (custom.value.tabsList.length < 8) {
    custom.value.tabsList.push({
      id: custom.value.tabsList.length,
      title: `标签${custom.value.tabsList.length + 1}`,
      checked: false,
      edit: false,
      nestedList: [
        {
          id: 0,
        },
      ],
    });
    toVisualization();
  } else {
    message.destroy();
    message.warning('最多添加八个标签');
  }
};

// 模块样式
const moduleList = ref(['fold_module_zero', 'fold_module_one', 'fold_module_two']);
const getModule = (index: number) => {
  custom.value.style = index;
  custom.value.senior.selecttTextColor =
    index == 1 && custom.value.senior.selecttTextColor !== '#FFFFFF' ? '#FFFFFF' : custom.value.senior.selecttTextColor;
  custom.value.senior.selecttTextColor =
    index !== 1 && custom.value.senior.selecttTextColor == '#FFFFFF' ? '#505D6F' : custom.value.senior.selecttTextColor;
  toVisualization();
};

// 编辑标签
const toEdit = (index: number, item: any) => {
  if (item.checked) {
    custom.value.tabsList[index].edit = !item.edit;
    toVisualization();
  }
};
// 删除标签
const deleteModal = ref(false);
const deleteIndex = ref(0);
const toDelete = (index: number) => {
  deleteModal.value = true;
  deleteIndex.value = index;
};
const deteleSelect = () => {
  if (custom.value.tabsList.length > 2) {
    custom.value.tabsList.splice(deleteIndex.value, 1);
    toVisualization();
    deleteModal.value = false;
  } else if (custom.value.tabsList.length <= 2) {
    message.destroy();
    message.warning('最少保留两个标签');
  }
};
const closeModal = () => {
  deleteModal.value = false;
};

// 标签单选
const getChecked = (index: number) => {
  custom.value.tabsList.map((res: any, tindex: number) => {
    res.edit = false;
    res.checked && index !== tindex ? (res.checked = false) : '';
  });
};

// 标题设置
const getTitle = () => {
  custom.value.title = title.value;
  toVisualization();
};
const getShowTitle = () => {
  custom.value.showTitle = showTitle.value;
  toVisualization();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: _normalizeClass(["horizontal_tab_name", setUp.value == index ? 'tab_name_click' : '']),
          onClick: ($event: any) => (getSetUp(index))
        }, [
          _createTextVNode(_toDisplayString(index == 0 ? '基础设置' : '高级设置') + " ", 1),
          _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
            [_vShow, setUp.value == index]
          ])
        ], 10, _hoisted_3)
      }), 64))
    ]),
    (setUp.value == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" 标题:"),
              _createVNode(_component_a_input, {
                value: title.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
                class: "title_input",
                placeholder: "请输入标签",
                maxlength: 4,
                onChange: getTitle
              }, null, 8, ["value"]),
              _createVNode(_unref(aCheckbox), {
                checked: showTitle.value,
                "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((showTitle).value = $event)),
                class: "checkbox",
                onChange: getShowTitle
              }, {
                default: _withCtx(() => [
                  _createTextVNode("隐藏")
                ]),
                _: 1
              }, 8, ["checked"])
            ]),
            _hoisted_9,
            _createVNode(_component_a_button, {
              class: "list_btn",
              onClick: addTab
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加标签")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", null, [
                  _createTextVNode(" 操作 "),
                  _createVNode(_unref(aTooltip), { placement: "left" }, {
                    title: _withCtx(() => [
                      _hoisted_13
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionCircleFilled), { class: "title_icon" })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.custom.tabsList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "table_content_every",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_unref(aCheckbox), {
                        class: "checkbox",
                        checked: item.checked,
                        "onUpdate:checked": ($event: any) => ((item.checked) = $event),
                        onChange: ($event: any) => (getChecked(index))
                      }, null, 8, ["checked", "onUpdate:checked", "onChange"]),
                      (item.checked && item.edit)
                        ? (_openBlock(), _createBlock(_component_a_input, {
                            key: 0,
                            value: item.title,
                            "onUpdate:value": ($event: any) => ((item.title) = $event),
                            maxlength: 4,
                            onChange: toVisualization
                          }, null, 8, ["value", "onUpdate:value"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.title), 1))
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_svg_icon, {
                        onClick: ($event: any) => (toEdit(index, item)),
                        class: "svg",
                        "icon-class": "edit"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_svg_icon, {
                        class: "svg",
                        "icon-class": "del",
                        onClick: ($event: any) => (toDelete(index))
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moduleList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["module_list_every", custom.value.style == index ? 'module_list_click' : '']),
                  key: index,
                  onClick: ($event: any) => (getModule(index))
                }, [
                  _createVNode(_component_svg_icon, { "icon-class": item }, null, 8, ["icon-class"]),
                  (custom.value.style == index)
                    ? (_openBlock(), _createBlock(_component_svg_icon, {
                        key: 0,
                        class: "select",
                        "icon-class": "horizontal_module_select"
                      }))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_20))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(Lable, {
          key: 1,
          lable: custom.value
        }, null, 8, ["lable"])),
    _createVNode(CDelModal, {
      visible: deleteModal.value,
      centered: "",
      close: closeModal,
      ok: deteleSelect
    }, null, 8, ["visible"])
  ]))
}
}

})